var p = (t, s, i) => {
  if (!s.has(t))
    throw TypeError("Cannot " + i);
};
var u = (t, s, i) => (p(t, s, "read from private field"), i ? i.call(t) : s.get(t)), r = (t, s, i) => {
  if (s.has(t))
    throw TypeError("Cannot add the same private member more than once");
  s instanceof WeakSet ? s.add(t) : s.set(t, i);
}, l = (t, s, i, e) => (p(t, s, "write to private field"), e ? e.call(t, i) : s.set(t, i), i);
var f = (t, s, i) => (p(t, s, "access private method"), i);
import { E as d } from "./Exporter-70879e53.mjs";
var h, a, n, o, x;
class v extends d {
  constructor(i, e, c) {
    super(i);
    r(this, o);
    r(this, h, 2500);
    r(this, a, 99999);
    r(this, n, null);
    e && l(this, h, e), c && l(this, a, c), f(this, o, x).call(this);
  }
}
h = new WeakMap(), a = new WeakMap(), n = new WeakMap(), o = new WeakSet(), x = function() {
  l(this, n, setInterval(() => {
    this.send(this.queue.splice(0, u(this, a)));
  }, u(this, h)));
};
export {
  v as default
};
